module.exports = {
  // PROXY_STAND: 'http://127.0.0.1:5000',
  PROXY_STAND: 'http://10.165.12.99:5000',
  PROXY_VIDEO: 'http://10.165.12.99:8080'
};
